import { render, staticRenderFns } from "./TeaserList.vue?vue&type=template&id=5c6829d8&"
import script from "./TeaserList.vue?vue&type=script&lang=js&"
export * from "./TeaserList.vue?vue&type=script&lang=js&"
import style0 from "./TeaserList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports